import { createFiveStarsAppConfig } from './feature-app-configs/create-five-stars-app-config';
import { FIVE_STARS_FEATURE_APP_CONTENT } from './feature-app-content/create-five-stars-content';

export const defaultAppConfig = {
  appsUMD: '/assets/five-stars/five-stars-umd.js',
  appsCommonsJS: '/assets/five-stars/five-stars-commonjs.js',
  appContent: FIVE_STARS_FEATURE_APP_CONTENT,
  createFunctionInstance: createFiveStarsAppConfig, // createMofaConfig
};
